module.exports = __webpack_public_path__ + "assets/img/gd2.b29752d0.jpg";